/* eslint-disable no-unused-vars */
import './index_mWeb.css';
import { View, Text } from '../../../component';
import { s, vs } from '../../../utilities/scaling_utils';
import Constants from '../../../constants';
import AnswerSwitchBtn from '../answer_switch_btn';
import Button from '@mui/material/Button/Button';
import { TiTick } from 'react-icons/ti';
import { RiCloseFill } from 'react-icons/ri';
import { BsInfoCircleFill } from 'react-icons/bs';
import { isDesktopBrowser } from '../../../utilities/helper';
import React from 'react';
import zIndex from '@mui/material/styles/zIndex';
import constants from '../../../constants';
interface Props {
  item?: any;
  qNo?: any;
  editMode?: any;
  onChangeMyAnswer?: any;
  onChange2x?: any;
  language?: any;
  onPressInsight?: any;
}
const YNAnswerViewMWeb = ({
  item,
  qNo,
  editMode = false,
  onChangeMyAnswer,
  onChange2x,
  language = 'en',
  onPressInsight
}: Props) => {
  const {
    point = 0,
    answerStatus = false,
    isAnswered = false,
    questions = {},
    imageUrl = ''
  } = item;
  const scoreColor = point > 0 ? '#00ff3c' : '#f52100';
  const { english: en = '', hindi: hi = '' } = questions;
  const question = language === 'en' ? en : hi;
  const buttonText = item.answer
    ? language === 'en'
      ? 'Yes'
      : 'हाँ'
    : language === 'en'
    ? 'No'
    : 'नहीं';
  const doubleUpText = language === 'en' ? 'Double Up' : 'दोगुना\xa0\xa0\xa0\xa0';
  const imageLink = imageUrl ? imageUrl : Constants.Images.DefaultPlayerImage;
  return (
    <View key={item.id} className="YNAnsView__container_mWeb">
      <View className="YNAnsView__QuestionNoWrapper_mWeb">
        <Text className="YNAnsView__QuestionNo_mWeb">{`Question : ${qNo}`}</Text>
      </View>
      <View className="YNAnsView__points__wrapper__MWeb">
        {isAnswered && (
          <div className="YNAnsView__points__status__container__mWeb">
            <div className={'YNAnsView__answer__point__mWeb'}>
              <Text
                style={{
                  color: scoreColor
                }}
                className={'YNAnsView__Point__mWeb'}>
                {answerStatus ? `+${point}` : `${point}`}
              </Text>
            </div>
            <div className="YNAnsView__answer__status__mWeb">
              {answerStatus > 0 ? (
                <img src={constants.Images.questionCorrectTick} width={'15px'} />
              ) : (
                <img src={constants.Images.questionWrongClose} width={'15px'} />
              )}
            </div>
          </div>
        )}
      </View>
      <View
        style={{
          height: '50%'
        }}
        className="YNAnsView__QuestionWrapper_mWeb">
        <Text className={'YNAnsView__Question_mWeb'}>{question}</Text>
      </View>
      <View
        style={{
          height: '50%',
          position: 'relative'
        }}
        className="YNAnsView__Content_mWeb">
        {editMode && (
          <View
            style={{
              position: 'absolute',
              left: '8px',
              zIndex: 10,
              top: '7px'
            }}
            onPress={onPressInsight}>
            <Constants.Svgs.Info />
          </View>
        )}
        <View
          style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}
          className="YNAnsView__PlayerWrapper_mWeb">
          <img src={`${imageLink}`} width={s(85)} height={s(85)} />
        </View>
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ alignItems: 'center', width: '100%' }} onPress={onChange2x}>
            <>
              {item.isPowerUp ? (
                <img src={Constants.Images.YesNo_2xBtnSelect_dark} width={s(35)} height={s(35)} />
              ) : (
                <img src={Constants.Images.YesNo_2xBtn_dark} width={s(35)} height={s(35)} />
              )}
              <Text
                style={{ marginTop: '10px', color: item.isPowerUp ? '#00ff3c' : 'white' }}
                className={'YNAnsView__DoubleUp_mWeb'}>{`${doubleUpText}`}</Text>
            </>
          </View>
        </View>
        <View
          style={{
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          {editMode ? (
            <AnswerSwitchBtn
              id={item.id + 'answer'}
              checked={item.answer}
              onChange={onChangeMyAnswer}
              optionLabels={language === 'en' ? ['Yes', 'No'] : ['हाँ', 'नहीं']}
            />
          ) : (
            <Button
              style={{
                backgroundColor: '#898989',
                color: '#fff',
                width: isDesktopBrowser ? s(50) : s(55),
                boxShadow: 'inset 0 0 6px 0 rgba(0, 0, 0, 0.38)'
              }}
              className="YNAnsView__Btn_mWeb">
              {`${buttonText}`}
            </Button>
          )}
        </View>
      </View>
    </View>
  );
};
export default React.memo(YNAnswerViewMWeb);

// <View
// key={item.id}
// style={{
//   marginTop: vs(30),
//   borderWidth: s(10),
//   paddingTop: vs(15),
//   paddingBottom: vs(15)
// }}
// className="YNAnsView__container_mWeb">
// <View
//   style={{
//     width: s(70),
//     left: s(0),
//     top: vs(-35),
//     paddingTop: vs(10),
//     paddingBottom: vs(10)
//   }}
//   className="YNAnsView__QuestionNoWrapper_mWeb">
//   <Text className="YNAnsView__QuestionNo_mWeb">{`Question : ${qNo}`}</Text>
// </View>
// <View
//   style={{
//     paddingTop: vs(5),
//     paddingBottom: vs(5)
//   }}
//   className="YNAnsView__Content_mWeb">
//   {editMode && (
//     <View
//       style={{
//         position: 'absolute',
//         left: s(1),
//         top: -vs(14)
//       }}
//       onPress={onPressInsight}>
//       <BsInfoCircleFill size={25} color={'#2a2728'} />
//     </View>
//   )}
//   <View
//     style={{
//       width: '80%',
//       paddingRight: s(60)
//     }}
//     className="YNAnsView__QuestionWrapper_mWeb">
//     <Text
//       style={{
//         fontSize: s(16)
//       }}
//       className={'YNAnsView__Question_mWeb'}>
//       {question}
//     </Text>
//   </View>
//   <View
//     style={{
//       width: '80%',
//       paddingRight: s(60),
//       marginTop: vs(10),
//       justifyContent: 'center',
//       alignItems: 'center'
//     }}>
//     {editMode ? (
//       <AnswerSwitchBtn
//         id={item.id + 'answer'}
//         checked={item.answer}
//         onChange={onChangeMyAnswer}
//         optionLabels={language === 'en' ? ['Yes', 'No'] : ['हाँ', 'नहीं']}
//       />
//     ) : (
//       <Button
//         style={{
//           backgroundColor: item.answer ? '#44c470' : '#d85656',
//           color: item.answer ? '#292727' : '#fff',
//           width: isDesktopBrowser ? s(50) : s(55)
//         }}
//         className="YNAnsView__Btn_mWeb">
//         {`${buttonText}`}
//       </Button>
//     )}
//   </View>
// </View>
{
  /* <View
  style={{
    marginRight: s(-5)
  }}
  className="YNAnsView__PlayerWrapper_mWeb">
  <img src={`${imageLink}`} width={s(85)} height={s(85)} />
</View> */
}
{
  /* <View
  style={{
    left: s(-5),
    bottom: vs(-5),
    borderBottomWidth: s(80),
    borderRightWidth: s(80),
    borderBottomColor: '#2a2728',
    borderRightColor: 'transparent',
    zIndex: 10
  }}
  className="YNAnsView__BottomLeft_mWeb">
  <View
    style={{
      marginTop: s(32),
      marginLeft: s(5)
    }}
    onPress={onChange2x}>
    <>
      {item.isPowerUp ? (
        <Constants.Svgs.YesNo_2xBtnSelect width={s(35)} height={s(35)} />
      ) : (
        <Constants.Svgs.YesNo_2xBtn width={s(35)} height={s(35)} />
      )}
      <Text
        style={{
          marginLeft: isDesktopBrowser ? -s(6) : -s(10),
          width: isDesktopBrowser ? s(50) : s(70)
        }}
        className={'YNAnsView__DoubleUp_mWeb'}>
        {`${doubleUpText}`}
      </Text>
    </>
  </View>
</View> */
}
// <View
//   style={{
//     right: s(-5),
//     top: vs(-5),
//     borderTopWidth: s(90),
//     borderTopColor: '#2a2728',
//     borderLeftWidth: s(90),
//     borderLeftColor: 'transparent'
//   }}
//   className="YNAnsView__TopRight_mWeb"
// />
// {isAnswered && (
//   <View
//     style={{
//       position: 'absolute',
//       right: s(-10),
//       top: vs(-15),
//       zIndex: 100,
//       alignItems: 'center'
//     }}>
//     {answerStatus > 0 ? (
//       <TiTick color={scoreColor} size={40} />
//     ) : (
//       <RiCloseFill fill={scoreColor} size={40} />
//     )}
//     <Text
//       style={{
//         color: scoreColor
//       }}
//       className={'YNAnsView__Point_mWeb'}>
//       {answerStatus ? `+${point}` : `${point}`}
//     </Text>
//   </View>
// )}
// </View>
